import script from "D:\\Kryzalis\\proquimil.com.br-2023\\frontend\\src\\assets\\js\\components\\BtnWhatsapp\\BtnWhatsappFixo.vue?type=script"
export * from "D:\\Kryzalis\\proquimil.com.br-2023\\frontend\\src\\assets\\js\\components\\BtnWhatsapp\\BtnWhatsappFixo.vue?type=script"
export default script